<template>
  <div class="top">
    <div class="icon">
      <img class="logo-img" src="@/assets/logo.png" alt="">
      <p>八斗故事村</p>
    </div>
    <div class="container">
      <div class="row card-row">
        <div class="col-lg-4" v-for="(page, index) in pageName" :key="index">
          <div class="custom-card">
            <div class="text-card" v-on:click="goToTargetPage(index);">
              <p v-html="page"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomePage',
  data() {
    return {
      pageList: ["Home", "Story", "About"],
      pageName: ["八斗里<br>簡介", "實境解謎", "製作團隊"],
    }
  },
  methods: {
    goToTargetPage(num) {
      this.$emit('updatePageIndex', num);
      this.$router.push({ name: this.pageList[num] });
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@600&display=swap');
.top {
  min-height: 100vh;
  height: 100%;
  width: auto;
  overflow: auto;
  background: linear-gradient(to bottom right, #2bace2, #ffffff);
  
  display: flex;
  align-items:center;
  justify-content:center;
  position: relative;
}
.icon {
  margin: 2rem 0 0 2rem;
  display: flex;
  position: absolute;
  top: 15px;
  left: 15px;
  color: #ffffff;
  font-size: 32px;
  p {
    font-family: "Noto Sans TC", sans-serif;
    margin-left: 1rem;
  }
}
.logo-img {
  margin-left: 10px;
  width: 73px;
  height: 50px;
  z-index: 20;
}
.card-row {
  height: 60vh;
}
.custom-card {
  background-color: #ffffff;
  margin: 50px 10px 50px 10px;
  height: 45vh;
  border-radius: 50px;
  box-shadow: 16px 17px 22px -18px rgba(0,0,0,0.30);
  transition: all 0.2s ease-out;
  cursor: pointer;
}
.text-card {
  font-family: "Noto Sans TC", sans-serif;
  height: 100%;
  display: flex;
  align-items:center;
  justify-content:center;
  color: #7bcadd;
  font-size: 56px;
  text-align: center;
  transform:scale(1);
}

.custom-card:hover {
  transform: scale(1.05);
}

</style>
